




















































































































































































































import Vue from 'vue';
import key from '@/libs/filters/key';
import util from '@/utils';
import { Component, Prop } from 'vue-property-decorator';
import { TLeadsForm } from '@/types/views/school';
import { getOrgList } from '@/api/school';
import { TOrgList } from '@/types/views/school'
declare var window: any;
declare var $: any;
@Component({})
export default class Search extends Vue {
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  handleOptions!: Function;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getData!: Function;
  @Prop(Boolean) shoulReset!: Boolean;
  private key: any = key;
  private loading = false;
  // 二次验证
  private secondary = true;
  private form: TLeadsForm = {
    phone: '',
    childName: '',
    firstCommStart: '',
    firstCommEnd: '',
    lastCommStart: '',
    lastCommEnd: '',
    nextCommStart: '',
    nextCommEnd: '',
    createTimeStart: '',
    createTimeEnd: '',
    saler: '',
    intention: '',
    dataStatus: '',
    isWxBinding: '',
    orgId: ''
  };
  // add by_ALi
  private orgList = []

  private created() {
    this.getOrgList({orgId: ''});
  }

  /**
   * 获取校区列表
   * @param {TOrgList} params
   */
  private async getOrgList(params: TOrgList) {
      try {
          let res: any = await getOrgList(params);
          console.log(res)
          this.orgList = res;
      } catch (e) {
          this.$message.error(e);
      }
  }

  private search() {
    const f = this.form,
      opts = {
        phone: f.phone,
        childName: f.childName,
        firstCommStart: util.toDate(f.firstCommStart),
        firstCommEnd: util.toDate(f.firstCommEnd),
        lastCommStart: util.toDate(f.lastCommStart),
        lastCommEnd: util.toDate(f.lastCommEnd),
        nextCommStart: util.toDate(f.nextCommStart),
        nextCommEnd: util.toDate(f.nextCommEnd),
        createTimeStart: util.toDate(f.createTimeStart),
        createTimeEnd: util.toDate(f.createTimeEnd),
        isWxBinding: f.isWxBinding,
        intention: f.intention,
        dataStatus: f.dataStatus,
        saler: f.saler,
        orgId: f.orgId
      };
    this.handleOptions(opts);
    this.getData();
  }
  private reset(arg: string) {
    if (arg === 'noFetch') return;
    this.form = {
      phone: '',
      childName: '',
      firstCommStart: '',
      firstCommEnd: '',
      lastCommStart: '',
      lastCommEnd: '',
      nextCommStart: '',
      nextCommEnd: '',
      createTimeStart: '',
      createTimeEnd: '',
      saler: '',
      intention: '',
      dataStatus: '',
      isWxBinding: '',
      orgId: ''
    };
    this.search();
  }
  private onExport() {
    try {
      const f = this.form,
        opts = {
          phone: f.phone,
          childName: f.childName,
          firstCommStart: util.toDate(f.firstCommStart),
          firstCommEnd: util.toDate(f.firstCommEnd),
          lastCommStart: util.toDate(f.lastCommStart),
          lastCommEnd: util.toDate(f.lastCommEnd),
          nextCommStart: util.toDate(f.nextCommStart),
          nextCommEnd: util.toDate(f.nextCommEnd),
          createTimeStart: util.toDate(f.createTimeStart),
          createTimeEnd: util.toDate(f.createTimeEnd),
          isWxBinding: f.isWxBinding,
          intention: f.intention,
          dataStatus: f.dataStatus,
          saler: f.saler,
          orgId: f.orgId
        };
      // 动态创建元素
      const iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      let src =
        process.env.VUE_APP_API + '/leads/downloadBLeads?' + $.param(opts);
      iframe.setAttribute('id', 'myFrame');
      (window.frames['myFrame'] as any).src = src;

      setTimeout(() => {
        document.body.removeChild(iframe);
        this.secondary = true;
      }, 30000);
    } catch (err) {
      this.$message.warning(err.message);
    }
  }
}
